import { render, staticRenderFns } from "./ScreenCaptureInfo.vue?vue&type=template&id=4f917b60"
import script from "./ScreenCaptureInfo.vue?vue&type=script&lang=js"
export * from "./ScreenCaptureInfo.vue?vue&type=script&lang=js"
import style0 from "./ScreenCaptureInfo.vue?vue&type=style&index=0&id=4f917b60&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports